import type { InboxV2DateRangeFilter, InboxV2Feed } from "../../../types";

export function applyInboxV2DateRangeToFilters(
  filters: InboxV2Feed["filters"],
  dateRange: InboxV2DateRangeFilter | undefined
): InboxV2Feed["filters"] {
  const messageMatch = filters.messageMatch;
  const usesMessageMatch = Boolean(
    messageMatch &&
    (messageMatch.messageType?.match === "or" ||
      messageMatch.sentiment?.match === "or" ||
      messageMatch.dateRange?.dateFrom ||
      messageMatch.dateRange?.dateTo)
  );

  if (usesMessageMatch) {
    return {
      ...filters,
      messageMatch: {
        ...messageMatch,
        dateRange: intersectInboxV2DateRanges(
          messageMatch?.dateRange,
          dateRange
        ),
      },
    };
  }

  return {
    ...filters,
    dateRange: intersectInboxV2DateRanges(filters.dateRange, dateRange),
  };
}

export function intersectInboxV2DateRanges(
  left: InboxV2DateRangeFilter | undefined,
  right: InboxV2DateRangeFilter | undefined
): InboxV2DateRangeFilter | undefined {
  if (!left?.dateFrom && !left?.dateTo) {
    return right;
  }

  if (!right?.dateFrom && !right?.dateTo) {
    return left;
  }

  return {
    dateFrom: maxIsoDate(left.dateFrom, right.dateFrom),
    dateTo: minIsoDate(left.dateTo, right.dateTo),
  };
}

function maxIsoDate(left: string | null, right: string | null) {
  if (!left) {
    return right;
  }

  if (!right) {
    return left;
  }

  return left > right ? left : right;
}

function minIsoDate(left: string | null, right: string | null) {
  if (!left) {
    return right;
  }

  if (!right) {
    return left;
  }

  return left < right ? left : right;
}
